import { Alert } from '@mui/material';
import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
    show: boolean;
};

const GradeMappingInfoAlert = ({ show }: Props): React.ReactElement => {
    const [display, setDisplay] = useState(show);
    useEffect(() => {
        setDisplay(show);
    }, [show]);

    const { t } = useTranslation();
    if (!display) return <></>;
    return (
        <Alert
            severity="info"
            onClose={() => setDisplay(false)}
            sx={{
                alignItems: 'center',
                fontSize: '14px',
            }}
        >
            {t('humanResources.settings.gradeMapping.mappingLeft')}
        </Alert>
    );
};

export default memo(GradeMappingInfoAlert);
